<div class="content-block">
  @if (articolo) {
    <form id="form-articolo">
      @if (valMod && !isNew) {
        <div style="width: 100%;  padding:10px; color:#fff; background-color:lightcoral">
        Attenzione! Dati modificati e non salvati.</div>
      }
      <dx-validation-group>
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="dx-field">
              <div class="dx-field-label">Codice </div>
              <div class="dx-field-value">
                <dx-text-box
                  placeholder=""
                  maxLength="50"
                  [(value)]="articolo.codice"
                  valueChangeEvent="keyup" (onValueChanged)="valoreModificato()">
                  <dx-validator>
                    <dxi-validation-rule type="required" message="Inserire il codice"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
            </div> <!-- fine field-->
            <div class="dx-field">
              <div class="dx-field-label">Descrizione </div>
              <div class="dx-field-value">
                <dx-text-box
                  placeholder=""
                  [(value)]="articolo.descrizione"
                  valueChangeEvent="keyup" (onValueChanged)="valoreModificato()">
                  <dx-validator>
                    <dxi-validation-rule type="required" message="Inserire la descrizione"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
            </div> <!-- fine field-->
            <div class="dx-field">
              <div class="dx-field-label">Attivo </div>
              <div class="dx-field-value">
                <dx-check-box [(value)]="articolo.attivo" (onValueChanged)="valoreModificato()"></dx-check-box>
              </div>
            </div> <!-- fine field-->
            <div class="dx-field">
              <div class="dx-field-label">Tipologia </div>
              <div class="dx-field-value">
                <dx-lookup [dataSource]="listTipoArticoli"
                  valueExpr="id"
                  displayExpr="descrizione"
                  [(value)]="articolo.idTipo"
                  clearButtonText="Reset"
                  showClearButton="true"
                  (onValueChanged)="valoreModificato()"
                  >
                  <dx-validator>
                    <dxi-validation-rule type="required" message="Richiesto"></dxi-validation-rule>
                  </dx-validator>
                </dx-lookup>
              </div>
            </div> <!-- fine field-->
            <div class="dx-field">
              <div class="dx-field-label">Taglia </div>
              <div class="dx-field-value">
                <dx-text-box
                  placeholder=""
                  [(value)]="articolo.taglia"
                  valueChangeEvent="keyup" (onValueChanged)="valoreModificato()">
                </dx-text-box>
              </div>
            </div> <!-- fine field-->
            <div class="dx-field">
              <div class="dx-field-label">Identificativo </div>
              <div class="dx-field-value">
                <dx-text-box
                  placeholder=""
                  [(value)]="articolo.identificativo"
                  valueChangeEvent="keyup" (onValueChanged)="valoreModificato()">
                </dx-text-box>
              </div>
            </div> <!-- fine field-->
            <div class="dx-field">
              <div class="dx-field-label">Note</div>
              <div class="dx-field-value">
                <dx-text-area [height]="200" [(value)]="articolo.note">
                </dx-text-area>
              </div>
            </div> <!-- fine field-->
          </div><!--Colonna 1-->
          <div class="col-12 col-md-6">
            <div class="dx-field">
              <div class="dx-field-label">Giorni scadenza</div>
              <div class="dx-field-value">
                <dx-number-box #numberBox
                  [(value)]="articolo.scadenza"
                  (onValueChanged)="valoreModificato()">
                  <dx-validator>
                    <dxi-validation-rule type="required" message="Inserire i giorni di scadenza"></dxi-validation-rule>
                  </dx-validator>
                </dx-number-box>
              </div>
            </div> <!-- fine field-->
            <div class="dx-field">
              <div class="dx-field-label">Scorta minima</div>
              <div class="dx-field-value">
                <dx-number-box #numberBox
                  [(value)]="articolo.scortaMinima"
                  (onValueChanged)="valoreModificato()">
                  <dx-validator>
                    <dxi-validation-rule type="required" message="Inserire la scorta minima"></dxi-validation-rule>
                  </dx-validator>
                </dx-number-box>
              </div>
            </div> <!-- fine field-->
            <div class="dx-field">
              <div class="dx-field-label">Scorta Massima</div>
              <div class="dx-field-value">
                <dx-number-box #numberBox
                  [(value)]="articolo.scortaMassima"
                  (onValueChanged)="valoreModificato()">
                </dx-number-box>
              </div>
            </div> <!-- fine field-->
            <div class="dx-field">
              <div class="dx-field-label">Giorni Lead</div>
              <div class="dx-field-value">
                <dx-number-box #numberBox
                  [(value)]="articolo.giorniLeadTime"
                  (onValueChanged)="valoreModificato()">
                </dx-number-box>
              </div>
            </div> <!-- fine field-->
            <div class="dx-field">
              <div class="dx-field-label">Qta Lotto riordino</div>
              <div class="dx-field-value">
                <dx-number-box #numberBox
                  [(value)]="articolo.qtaLottoRiordino"
                  (onValueChanged)="valoreModificato()">
                </dx-number-box>
              </div>
            </div> <!-- fine field-->
            <div class="dx-field">
              <div class="dx-field-label">Gestione Kit</div>
              <div class="dx-field-value">
                <dx-check-box #numberBox
                  [(value)]="articolo.gestioneKit"
                  (onValueChanged)="valoreModificato()">
                </dx-check-box>
              </div>
            </div> <!-- fine field-->
          </div><!-- colonna 2-->
        </div>
        <div class="row">
        </div>
        <div class="row">
          <div class="col-12">
            <div class="dx-field div-buttons">
              <dx-button stylingMode="contained" text="Salva" icon="save" type="success" width="120"
                (onClick)="SalvaArticolo($event)">
              </dx-button>
              <dx-button stylingMode="contained" text="Stampa Etichetta" icon="print" type="normal" width="140" (onClick)="stampaEtichetta()"></dx-button>
            </div>
          </div>
        </div>
      </dx-validation-group>
    </form>
  }
</div>

<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="loadPanelVisible"
  [showIndicator]="true" [showPane]="true" [shading]="true" [hideOnOutsideClick]="false">
</dx-load-panel>

@if(popupInfoBarCode){
<dx-popup [width]="600" [height]="250" [showTitle]="true" title="Informazioni Aggiuntive" [dragEnabled]="false"
  [hideOnOutsideClick]="true" [(visible)]="popupInfoBarCode">
  <app-popup-barcode (popupBarcodeEventEmitter)="onPopupBarcodeEventEmitter($event)"></app-popup-barcode>
</dx-popup>
}
